module.exports = __webpack_public_path__ + "static/media/curriculumKit__software--blockly.393276b1.jpg";